/* Progressive, user-triggered reading dialogs. Never writes to cart, history or storage. */
(() => {
  'use strict';
  if (window.DV6PlusModals) return;
  window.DV6PlusModals = true;
  let current = null;
  const announce = open => document.dispatchEvent(new CustomEvent('dv6:modal:state', {detail:{open}}));
  function finish(state) {
    if (!state || state.done) return;
    state.done = true;
    if (state.overflow) document.body.style.setProperty('overflow', state.overflow, state.priority);
    else document.body.style.removeProperty('overflow');
    if (state.marker.isConnected) state.marker.replaceWith(state.dialog);
    else state.dialog.remove();
    if (current === state) current = null;
    announce(false);
    if (state.trigger.isConnected) state.trigger.focus({preventScroll:true});
  }
  function closeCurrent() {
    if (!current) return;
    const state = current;
    if (state.dialog.open) state.dialog.close();
    finish(state);
  }
  function open(dialog, trigger) {
    if (typeof dialog.showModal !== 'function') return false;
    closeCurrent();
    const marker = document.createComment('dv6-dialog-position');
    dialog.before(marker);
    const state = {dialog,trigger,marker,done:false,
      overflow:document.body.style.getPropertyValue('overflow'),
      priority:document.body.style.getPropertyPriority('overflow')};
    try {
      document.body.appendChild(dialog);
      dialog.showModal();
      current = state;
      document.body.style.setProperty('overflow','hidden');
      dialog.addEventListener('close', () => finish(state), {once:true});
      dialog.querySelector('.dv6-modal__title')?.focus({preventScroll:true});
      announce(true);
      return true;
    } catch (_) {
      finish(state);
      return false; // Preserve the source page link when enhancement is unsupported.
    }
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-dv6-modal-open]');
    if (opener) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = document.getElementById(opener.dataset.dv6ModalOpen);
      if (dialog?.matches('dialog[data-dv6-modal]') && open(dialog,opener)) event.preventDefault();
      return;
    }
    if (!current) return;
    if (event.target.closest('[data-dv6-modal-close]') && current.dialog.contains(event.target)) {
      event.preventDefault();closeCurrent();return;
    }
    if (event.target === current.dialog) {
      const box = current.dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeCurrent();
    }
  });
  document.addEventListener('keydown', event => {
    if (!current || event.key !== 'Tab') return;
    const nodes = [...current.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')]
      .filter(node => node.tabIndex >= 0 && node.getClientRects().length > 0);
    if (!nodes.length) { event.preventDefault(); current.dialog.querySelector('.dv6-modal__title')?.focus(); return; }
    const index = nodes.indexOf(document.activeElement);
    if (index === -1 || (event.shiftKey && index === 0) || (!event.shiftKey && index === nodes.length - 1)) {
      event.preventDefault(); nodes[event.shiftKey ? nodes.length - 1 : 0].focus();
    }
  });
  document.addEventListener('shopify:section:unload', event => {
    if (current && event.target.contains?.(current.marker)) closeCurrent();
  });
})();
